import React from "react";
import AdminNcaaCalendarModule from "@/components/admin/ncaa-calendar/AdminNcaaCalendarModule";

const EditorNcaaCalendar: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-heading font-bold text-primary-700">NCAA Calendar Management</h1>
        <p className="text-gray-600">Manage NCAA calendar events and important recruiting dates</p>
      </div>

      <AdminNcaaCalendarModule />
    </div>
  );
};

export default EditorNcaaCalendar;